import { createSlice } from '@reduxjs/toolkit'
import { createPerformance, getChartPrep, getChartQc, getPerformanceDetail, getDaySessionList, getPerformanceDetailSession, editPerformance } from './dashboard.api'

export interface DashboardState {
    loading: boolean,
    chartQcData: any,
    chartPrepData: any,
    performanceDetail: any,
    daySessionList: any,
    performanceByTimestamp: any,
}
const initialState: DashboardState = {
    loading: false,
    chartQcData: [],
    chartPrepData: [],
    performanceDetail: [],
    daySessionList: [],
    performanceByTimestamp: [],
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getChartQc.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getChartQc.fulfilled, (state, action) => {
            state.loading = false
            state.chartQcData = action.payload.data.data
        })
        builder.addCase(getChartQc.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(getChartPrep.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getChartPrep.fulfilled, (state, action) => {
            state.loading = false
            state.chartPrepData = action.payload.data.data
        })
        builder.addCase(getChartPrep.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(createPerformance.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(createPerformance.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(createPerformance.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(editPerformance.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(editPerformance.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(editPerformance.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(getPerformanceDetail.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getPerformanceDetail.fulfilled, (state, action) => {
            state.loading = false
            state.performanceDetail = action.payload.data
        })
        builder.addCase(getPerformanceDetail.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(getDaySessionList.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getDaySessionList.fulfilled, (state, action) => {
            state.loading = false
            state.daySessionList = action.payload.data
        })
        builder.addCase(getDaySessionList.rejected, (state, action) => {
            state.loading = false
        })

        builder.addCase(getPerformanceDetailSession.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(getPerformanceDetailSession.fulfilled, (state, action) => {
            state.loading = false
        })
        builder.addCase(getPerformanceDetailSession.rejected, (state, action) => {
            state.loading = false
        })
    },
})

export default dashboardSlice.reducer